import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { Link, useNavigate } from "react-router-dom";
import icons from "../../constants/icons";
import { logout } from "../../redux/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { menuGroups } from "../../constants/menuGroups";

const settings = ["Cerrar Sesión"];

const Header = () => {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorElGroup, setAnchorElGroup] = useState(null);
  const [openGroup, setOpenGroup] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const allowedRoutes = useSelector((state) => state?.user?.allowedRoutes || []);

  const visibleGroups = menuGroups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => allowedRoutes.includes(item.path)),
    }))
    .filter((group) => group.items.length > 0);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const handleOpenNavMenu = (event) => setAnchorElNav(event.currentTarget);
  const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
    setOpenGroup(null);
    setAnchorElGroup(null);
  };
  const handleCloseUserMenu = () => setAnchorElUser(null);

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: "transparent", boxShadow: "none" }}
    >
      <div className="HContainer a-center">
        <Link
          to={allowedRoutes[0] || "/"}
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none"
          }}
        >
          <img
            className="w-icon-35 icon-margin-r-15"
            src={icons.bill}
            alt="icon"
            style={{ marginRight: 15 }}
          />
          <Typography
            variant="h6"
            noWrap
            sx={{
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "#006eb7",
              textDecoration: "none"
            }}
          >
            NovaBilling
          </Typography>
        </Link>

        {/* Desktop Menu - por grupos según permisos */}
        <Box
          sx={{
            flexGrow: 1,
            display: { xs: "none", md: "flex" },
            marginLeft: 3
          }}
        >
          {visibleGroups.map((group) => (
            <Box key={group.title} sx={{ mr: 3 }}>
              <Button
                onClick={(e) => {
                  setOpenGroup(group.title);
                  setAnchorElGroup(e.currentTarget);
                }}
                sx={{
                  color: "#006eb7",
                  fontWeight: "normal",
                  textTransform: "none",
                  fontSize: "16px",
                  "&:hover": { color: "#005493" }
                }}
              >
                {group.title}
              </Button>
              <Menu
                anchorEl={openGroup === group.title ? anchorElGroup : null}
                open={openGroup === group.title}
                onClose={() => {
                  setOpenGroup(null);
                  setAnchorElGroup(null);
                }}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
              >
                {group.items.map((item) => (
                  <MenuItem
                    key={item.path}
                    onClick={() => {
                      setOpenGroup(null);
                      setAnchorElGroup(null);
                      navigate(item.path);
                    }}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          ))}
        </Box>

        {/* Menú móvil */}
        <Box
          sx={{
            flexGrow: 1,
            display: { xs: "flex", md: "none" },
            justifyContent: "flex-end"
          }}
        >
          <IconButton
            size="large"
            aria-label="menu"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenNavMenu}
            color="inherit"
          >
            <img
              className="w-icon-25 icon-margin-r-15"
              src={icons.menu}
              alt="menu icon"
            />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            keepMounted
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
            sx={{ display: { xs: "block", md: "none" } }}
          >
            {visibleGroups.map((group) => (
              <React.Fragment key={group.title}>
                <MenuItem disabled>
                  <Typography sx={{ fontWeight: "bold" }}>{group.title}</Typography>
                </MenuItem>
                {group.items.map((item) => (
                  <MenuItem
                    key={item.path}
                    onClick={() => {
                      handleCloseNavMenu();
                      navigate(item.path);
                    }}
                  >
                    <Typography sx={{ color: "#006eb7" }}>{item.label}</Typography>
                  </MenuItem>
                ))}
              </React.Fragment>
            ))}
          </Menu>
        </Box>

        {/* User Menu */}
        <Box sx={{ flexGrow: 0 }}>
          <Tooltip title="Menu de usuario">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <img
                className="w-icon-25 icon-margin-r-15"
                src={icons.userMenu}
                alt="user menu icon"
              />
            </IconButton>
          </Tooltip>
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {settings.map((setting) => (
              <MenuItem
                key={setting}
                onClick={() => {
                  handleCloseUserMenu();
                  if (setting === "Cerrar Sesión") handleLogout();
                }}
              >
                <Typography textAlign="center">{setting}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </div>
    </AppBar>
  );
};

export default Header;
